import React, { PropsWithChildren } from "react";
import styles from "./style.module.scss";

/**
 * @deprecated move to common
 * @param props
 * @returns
 */
function Sticky(props: PropsWithChildren<Props>) {
  return (
    <div
      className={styles.sticky}
      style={{ top: props.top, bottom: props.bottom, zIndex: props.zIndex }}
    >
      {props.children}
    </div>
  );
}

interface Props {
  top?: number;
  bottom?: number;
  zIndex?: number;
}

export default Sticky;
